import React, { useRef } from 'react';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import { Chart as ChartJS } from 'react-chartjs-2';
import { formatarDecimal, formatLargeNumber } from '../../core/utils/funcoes';
import { FiltroSopProduction } from '../../core/repositories/sopProductionRepositorio';
import { useTranslation } from 'react-i18next';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useToast } from '../../core/contexts/toast';
import { RepositorioSopProduction } from '../../core/repositories/sopProductionRepositorio';
import { useAutenticação } from '../../core/contexts/auth';
import { customPlugin, optionsChart } from '../SopSales/SopSalesSalesForecastChart';

interface Props {
    filtro: FiltroSopProduction;
    valor?: number;
}

const SopProductionGrowthChart: React.FC<Props> = (props) => {
    const chartRef = useRef<Chart<'bar'>>(null);
    const { mostrarToast } = useToast();
    const { t } = useTranslation();
    const [data, setData] = React.useState<ChartData<"bar" | "line">>({} as ChartData<"bar" | "line">);
    const [carregando, setCarregando] = React.useState(true);
    const { usuario } = useAutenticação()

    React.useEffect(() => {
        if (usuario && usuario.cod_usuario) {
            setCarregando(true);
            props.filtro.cod_usuario = usuario.cod_usuario;
            new RepositorioSopProduction().postProduction(props.filtro).then((res) => {
                const labels: string[] = [];
                const real: (number | null)[] = [];
                const forecastDestaque: (number | null)[] = [];

                const forecast: (number | null)[] = [];
                const budget: (number | null)[] = [];
                const forecastReal: (number | null)[] = [];

                res.forEach((item: any) => {
                    labels.push(item.mes || "");
                    real.push(item.real ?? null);
                    budget.push(item.hasOwnProperty('budget') ? item.budget : null);
                    // forecastDestaque.push(item.num_production_new || null);
                    forecast.push(Math.max((item.forecast || 0), (item.num_production_new || 0)));
                    forecastDestaque.push(item.num_production_new);
                    forecastReal.push(item.forecast)

                });

                setData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Actual',
                            data: real,
                            borderColor: '#1e88e5',
                            backgroundColor: '#1e88e5',
                            // tension: 0.4,
                            // pointRadius: 4,
                            // fill: false,
                        },
                     
                        {
                            label: 'Forecast - Edit',
                            data: forecastDestaque,
                            showLine: false,
                            borderWidth: 0,
                            backgroundColor: 'transparent',
                            pointRadius: 0,
                            type: 'line',
                        },
                        {
                            label: 'Forecast - Real',
                            data: forecastReal,
                            borderWidth: 0,
                            backgroundColor: 'transparent',
                            pointRadius: 0,
                            type: `line`,
                        },
                        {
                            label: 'Forecast',
                            data: forecast,
                            borderColor: '#90CAF9',
                            backgroundColor: '#90CAF9',
                            // tension: 0.4,
                            // pointRadius: 3,
                            // fill: false,
                        },
                        {
                            label: 'Budget',
                            type: 'line', // <- Isso transforma em linha
                            data: budget,
                            borderColor: '#9e9e9e',
                            // borderDash: [3, 3],
                            backgroundColor: '#9e9e9e',
                            pointRadius: 0,
                            fill: false,
                        }

                    ],
                });
                setCarregando(false);
            }).catch((error) => {
                mostrarToast({
                    titulo: t("pages.Erro!"),
                    mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                    tipo: "error",
                });
            })
        }
    }, [props.filtro, usuario]);

    const options = () => {
        return optionsChart(props)
    }

    return (

        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">Production</strong>
            {carregando ?
                <SopLoadingAnimation type="CHARTS" />
                :
                <div>
                    <ChartJS  id="production" ref={chartRef} type='bar' options={options()} data={data} plugins={[{ id: 'partialBarHighlight2', afterDatasetsDraw: customPlugin }]} />
                </div>
            }

        </div>
    );
};

export default SopProductionGrowthChart;